import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../mensajes2";
import { Dimmer } from "../spinner";
import axios from "axios";
const ModalSecuenciaPlantilla = (props) => {
  const op = require("@/modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [body, setBody] = useState({
    secuencia: "",
    numPlanilla: "",
    numOrdenPago: "",
  });
  const onChange = (e) => {
    const { name, value } = e.target;
    setBody((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const actualizarSecuencia = () => {
    setLoading(true);
    const endpoint = `${op.conexion}/api/administracion/actualizar-secuencia-plantilla`;
    axios
      .put(
        endpoint,
        {
          idEfiscal: idefiscal,
          numOrdenPago: body.numOrdenPago,
          secuencia: body.secuencia,
        },
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        },
      )
      .then((response) => {
        if (response.status === 200 && response.data) {
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "Secuencia Actualizada",
            icono: "exito",
          });
        } else {
           setMensaje({
            mostrar: true,
            titulo: "Error.",
            texto: "Orden de Pago no Encontrada",
            icono: "error",
          });
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto:
            error.response?.data?.message ||
            "Error al conectar con el servidor",
          icono: "error",
        });
      })
      .finally(() => setLoading(false));
  };

  const cerrar = () => {
    props.onHidde();
    props.actualizarPlantilla();
  };
  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      size="ms"
      contentClassName="p-0 m-0"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        if (props.planilla) {
          setBody({
            secuencia: props.planilla.secuencia,
            numPlanilla: props.planilla.numeroplanilla,
            numOrdenPago: props.planilla.numordenpago,
          });
        }
      }}
    >
      <Modal.Header className="azulGradiant">
        <h3 className="fw-bold text-light m-0 text-uppercase">
          Actualizar Secuencia Plantilla
        </h3>
        <button className="btn btn-sm bg-light m-0" onClick={() => cerrar()}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body className="d-flex justify-content-between row">
        <div className="col-md-12 row mx-auto align-items-start">
          <div className="col-md-12 row my-1 py-1">
            <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
              <span
                className="input-group-text text-uppercase"
                id="inputGroup-sizing-sm"
              >
                Orden de Pago
              </span>
              <input
                className="form-control text-uppercase"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                name="numOrdenPago"
                value={body.numOrdenPago}
                onChange={onChange}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          style={{ margin: "2px" }}
          className="fw-bold btn btn-primary btn-sm rounded-pill"
          onClick={() => actualizarSecuencia()}
        >
          <i className="fa fa-check"> Aceptar</i>
        </button>

        <button
          onClick={() => cerrar()}
          type="button"
          style={{ margin: "2px" }}
          className="fw-bold btn btn-danger btn-sm rounded-pill"
        >
          <i className="fa fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
          if (mensaje.titulo === "Exito.") {
            cerrar();
          }
        }}
      />
      <Dimmer active={loading} inverted />
    </Modal>
  );
};
export default ModalSecuenciaPlantilla;
